module.exports = __webpack_public_path__ + "static/media/20.11fb8131.png";